import type { ChatMessageView } from "@neon-arena/shared";
import type { ClientNetwork } from "../networking/ClientNetwork.js";

export class ChatPanel {
  private el: HTMLDivElement;
  private messages: HTMLDivElement;
  private input: HTMLInputElement;

  constructor(private net: ClientNetwork) {
    this.el = document.getElementById("chat-panel") as HTMLDivElement;
    this.messages = document.getElementById("chat-messages") as HTMLDivElement;
    this.input = document.getElementById("chat-input") as HTMLInputElement;

    document.getElementById("chat-send")!.addEventListener("click", () => this.send());

    this.input.addEventListener("keydown", (e) => {
      if (e.code === "Enter") { this.send(); this.input.blur(); }
      if (e.code === "Escape") this.input.blur();
    });

    net.onChat((msg) => this.append(msg));
  }

  show(): void {
    this.el.classList.remove("hidden");
  }

  hide(): void {
    this.el.classList.add("hidden");
  }

  private send(): void {
    const text = this.input.value.trim();
    if (!text) return;
    this.net.sendChat(text);
    this.input.value = "";
  }

  private append(msg: ChatMessageView): void {
    const row = document.createElement("div");
    row.className = "chat-row";

    const nameEl = document.createElement("span");
    nameEl.className = "chat-name";
    nameEl.textContent = msg.playerName;

    const textEl = document.createElement("span");
    textEl.className = "chat-text";
    textEl.textContent = msg.text;

    row.appendChild(nameEl);
    row.appendChild(document.createTextNode(" "));
    row.appendChild(textEl);

    this.messages.appendChild(row);
    while (this.messages.children.length > 50) this.messages.firstChild?.remove();
    this.messages.scrollTop = this.messages.scrollHeight;
  }
}
